import { z } from 'zod';
export const EnergyEfficiencyClassSchema = z.enum(['a_plus', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'unknown']);
export const EnergyEfficiencyClassSummarySchema = z.object({
    energy_efficiency_class: EnergyEfficiencyClassSchema,
    count: z.number(),
});
export const FuelTypeSummarySchema = z.object({
    fuel_type: z.string(),
    count: z.number(),
});
export const EnergySummarySchema = z.object({
    primary_power_consumption: z.number(),
    total_carbon_dioxide_equivalent: z.number(),
    energy_efficiency_class_summary: EnergyEfficiencyClassSummarySchema.array(),
    fuel_type: FuelTypeSummarySchema.array(),
});
export const AssetEnergySummarySchema = z.object({
    primary_power_consumption: z.number(),
    total_carbon_dioxide_equivalent: z.number(),
    energy_efficiency_classes: z.array(z.string()),
    fuel_types: z.array(z.enum([
        'wood',
        'gas',
        'oil',
        'environmental_soil',
        'environmental_air',
        'environmental_solar',
        'electric_power',
        'erdgas',
        'fluessiggas',
        'heizoel_el',
        'strom',
        'nah_fernwaerme',
        'holzpellets',
        'holzhackschnitzel',
        'stueckholz',
        'waermepumpe',
        'solarthermie',
        'geothermie',
        'umweltwaerme',
        'hybrid_system',
        'biogas_biomethan',
        'steinkohle',
        'braunkohle',
    ])),
});
